import { render } from "./CustomizeSelectCreativeDialog.vue?vue&type=template&id=52dc50f4"
import script from "./CustomizeSelectCreativeDialog.vue?vue&type=script&lang=js"
export * from "./CustomizeSelectCreativeDialog.vue?vue&type=script&lang=js"

import "./CustomizeSelectCreativeDialog.vue?vue&type=style&index=0&id=52dc50f4&lang=scss&scope=true"

import exportComponent from "/data/projects/private_futurelab/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__